export default __webpack_public_path__ + "static/media/clock.c901678e.svg";